export default "__VITE_ASSET__a301b493__"